import { createSlice } from '@reduxjs/toolkit';
import { IAction } from '../store';

export interface IImportDataState {
    searchText: string;
    expandedNodes: 'all' | string[];
    editingActive: boolean;
    currentView: string;
}

const initialState: IImportDataState = {
    searchText: '',
    expandedNodes: [],
    editingActive: false,
    currentView: '',
};

const reducers = {
    setSearchText(state: IImportDataState, action: IAction<string>) {
        state.searchText = action.payload;
    },
    setExpandedNodes(state: IImportDataState, action: IAction<'all' | string[]>) {
        state.expandedNodes = action.payload;
    },
    setEditingActive(state: IImportDataState, action: IAction<boolean>) {
        state.editingActive = action.payload;
    },
    setCurrentView(state: IImportDataState, action: IAction<string>) {
        state.currentView = action.payload;
    },
};

export const importDataSlice = createSlice({
    name: 'importData',
    initialState,
    reducers,
});

export const { setSearchText, setExpandedNodes, setEditingActive, setCurrentView } =
    importDataSlice.actions;

export default importDataSlice.reducer;
